// src/services/CartService.js (or wherever)
export const CART_KEY = "guestCart"; // <- consistent key used across the app

export function saveGuestCart(cart) {
    try {
        localStorage.setItem(CART_KEY, JSON.stringify(cart));
    } catch (e) {
        console.error("Failed to save guest cart:", e);
    }
}

export function getGuestCart() {
    try {
        const raw = JSON.parse(localStorage.getItem(CART_KEY) || "[]");
        return Array.isArray(raw) ? raw : [];
    } catch (e) {
        console.warn("Failed to parse guest cart:", e);
        return [];
    }
}

export function addToGuestCart(product, quantity = 1) {
    const cart = getGuestCart(); // reads from CART_KEY now
    // find existing by product id (works if stored shape is { id, product, ... } or plain product)
    const existing = cart.find((item) => {
        const pid = item.product ?.id ?? item.id;
        return pid === product.id;
    });

    if (existing) {
        existing.quantity = (existing.quantity || 1) + quantity;
    } else {
        // store stable shape: { id, product, quantity }
        cart.push({
            id: product.id,
            product: { ...product
            },
            quantity,
        });
    }

    saveGuestCart(cart);
    return cart;
}

export function clearGuestCart() {
    try {
        localStorage.removeItem(CART_KEY);
    } catch (e) {
        console.error("Failed to clear guest cart:", e);
    }
}